/* "An der Wand" auf der Print-Produktseite.

   Ein Foto vom Wohnzimmer (rosa Putz, Blumensofa, Sideboard), die Wand leer.
   Hier wird das Werk in echter Groesse draufgelegt: das Auswahlfeld oben
   (Format / Rahmen) steuert Preis, Warenkorb und dieses Bild. Kein eigenes
   Bedienelement.

   Massstab und Bildmitte kommen als data-Attribute vom Liquid (Anteile der
   Bildbreite/-hoehe, aus dem Sofa als 150 cm abgeleitet). Das Skript rechnet
   nur cm -> Pixel und setzt vier Werte. Bei Groessenwechsel des Fensters
   rechnet es neu, damit der Massstab in jeder Spaltenbreite stimmt.

   Vorgeschichte: erst ein Three.js-Wohnzimmer (600 KB, verworfen), dann eine
   Strichzeichnung mit Sofa (bis 07.09.2026). Das Foto beantwortet "wie gross
   ist das" und "wie sieht das bei mir aus" in einem Bild. */

(() => {
  const wurzel = document.querySelector('[data-print-size]');
  if (!wurzel) return;

  const auswahl = document.querySelector('[data-product-variant-select]');
  const raum = wurzel.querySelector('[data-print-size-room]');
  const werk = wurzel.querySelector('[data-print-size-artwork]');
  const beschriftung = wurzel.querySelector('[data-print-size-label]');
  if (!raum || !werk) return;

  const MITTE_X = Number(raum.dataset.mitteX);   // Anteil der Bildbreite
  const MITTE_Y = Number(raum.dataset.mitteY);   // Anteil der Bildhoehe
  const CM = Number(raum.dataset.cm);            // Anteil der Bildbreite je cm

  /* Gelatos Fine Art Framed Poster: Kiefernrahmen 10-14 mm breit. 1,2 cm
     als Mitte, sichtbar genug, ohne das Motiv zu erdruecken. */
  const RAHMEN_CM = 1.2;

  const formate = new Map();
  wurzel.querySelectorAll('[data-format]').forEach((el) => {
    formate.set(el.dataset.variant, {
      breite: Number(el.dataset.breite),
      hoehe: Number(el.dataset.hoehe),
      label: el.dataset.format,
      rahmen: el.dataset.rahmen === '1',
    });
  });

  let aktuell = null;

  function zeige(f) {
    const W = raum.clientWidth;
    const H = raum.clientHeight;
    if (!W || !H) return;
    const px = W * CM;                       // Pixel je Zentimeter
    const breite = f.breite * px;
    const hoehe = f.hoehe * px;
    const rahmen = f.rahmen ? RAHMEN_CM * px : 0;
    const links = W * MITTE_X - breite / 2 - rahmen;
    const oben = H * MITTE_Y - hoehe / 2 - rahmen;

    werk.style.left = `${links}px`;
    werk.style.top = `${oben}px`;
    werk.style.width = `${breite}px`;
    werk.style.height = `${hoehe}px`;
    werk.style.borderWidth = `${rahmen}px`;
    werk.classList.toggle('is-framed', f.rahmen);

    if (beschriftung) {
      const masse = `${f.breite.toLocaleString('de-DE')} × ${f.hoehe.toLocaleString('de-DE')} cm`;
      beschriftung.textContent = f.rahmen
        ? `${f.label} · ${masse} · schwarzer Holzrahmen`
        : `${f.label} · ${masse}`;
    }
  }

  function aktualisiere() {
    const f = formate.get(auswahl ? auswahl.value : '');
    if (!f) return;
    aktuell = f;
    zeige(f);
  }

  if (auswahl) auswahl.addEventListener('change', aktualisiere);

  // Neu rechnen, wenn das Foto seine Breite aendert (Fenster, Drehen des Geraets).
  if ('ResizeObserver' in window) {
    new ResizeObserver(() => { if (aktuell) zeige(aktuell); }).observe(raum);
  } else {
    window.addEventListener('resize', () => { if (aktuell) zeige(aktuell); });
  }

  // Erst rechnen, wenn das Foto seine Hoehe hat — sonst ist clientHeight 0.
  const foto = raum.querySelector('img');
  if (foto && !foto.complete) foto.addEventListener('load', aktualisiere, { once: true });
  aktualisiere();
})();
